import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@babackapp/ui/components/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@babackapp/ui/components/popover";
import { useState } from "react";
import { ShopImportMappingColumnType } from "./import-settings-form-types";

type ImportPropertySelectProps = {
  value?: string | null;
  onChange: (mapTo: ShopImportMappingColumnType) => void;
};

export default function ImportPropertySelect({
  value,
  onChange,
}: ImportPropertySelectProps) {
  const options = useFieldSelectionOptions();
  const [open, setOpen] = useState(false);
  const t = useTranslation();
  const valueLabel = options.find((option) => option.key === value)?.label;

  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="w-[150px] justify-start">
          {valueLabel ?? options[0].label}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0" side="bottom" align="center">
        <Command>
          <CommandInput />
          <CommandList>
            <CommandEmpty>{t("misc.noResultFound")}</CommandEmpty>
            <CommandGroup>
              {options.map((option) => (
                <CommandItem
                  key={option.key}
                  value={option.key}
                  onSelect={(value) => {
                    if (value === "nothing") onChange(null);
                    else onChange(value as ShopImportMappingColumnType);
                    setOpen(false);
                  }}
                >
                  <span>{option.label}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

function useFieldSelectionOptions() {
  const t = useTranslation();
  return [
    {
      key: "nothing",
      label: "Unused",
    },
    {
      key: "returnRequestIdColumn",
      label: t("settings.integrations.imports.addImport.returnRequestIdColumn"),
    },
    {
      key: "orderIdColumn",
      label: t("settings.integrations.imports.addImport.orderIdColumn"),
    },
    {
      key: "orderNameColumn",
      label: t("settings.integrations.imports.addImport.orderNameColumn"),
    },
    {
      key: "logisticCodeColumn",
      label: t("settings.integrations.imports.addImport.logisticCodeColumn"),
    },
    {
      key: "skuColumn",
      label: t("settings.integrations.imports.addImport.skuColumn"),
    },
    {
      key: "barCodeColumn",
      label: t("settings.integrations.imports.addImport.barCodeColumn"),
    },
    {
      key: "lineItemIdColumn",
      label: t("settings.integrations.imports.addImport.lineItemIdColumn"),
    },
    {
      key: "quantityColumn",
      label: t("settings.integrations.imports.addImport.quantityColumn"),
    },
    {
      key: "resultColumn",
      label: t("settings.integrations.imports.addImport.resultColumn"),
    },
    {
      key: "reasonColumn",
      label: t("settings.integrations.imports.addImport.reasonColumn"),
    },
    {
      key: "commentColumn",
      label: t("settings.integrations.imports.addImport.commentColumn"),
    },
  ];
}
